import { AbstractControl, ValidatorFn } from "@angular/forms";

export function existingSubmittingEntityNameValidator( existingSubmittingEntityNames: string[] ): ValidatorFn {
  return (control: AbstractControl) : { [key: string]: boolean } | null => {
    if (control.value && existingSubmittingEntityNames.map(x => x.trim().toLowerCase()).includes(control.value.trim().toLowerCase())) {
      return { 'existingSubmittingEntityName': true };
    }
    return null;
  };
}



// WEBPACK FOOTER //
// ./src/app/common/validators/existingSubmittingEntityNameValidator.ts